import { observer } from 'mobx-react-lite';
import { Col, Container, Row } from 'react-bootstrap';

const TermsOfUse = (): JSX.Element => {

    return (
    <Container className='mt-5'>
      <Row>
        <Col>
          <h1>SprayPlan Manager Terms of Use</h1>
          <p>Last Updated: 28 May 2026</p>
        </Col>
      </Row>
 
      <Row>
        <Col>
          <p>SprayPlan Manager ("SPM") is operated by HortPlus N.Z. Limited ("HortPlus").</p>
          <p>By using SPM, you agree to these Terms.</p>
        </Col>
      </Row>
 
      <Row>
        <Col>
          <h2>Use of SPM</h2>
          <p>SPM is provided as a tool to assist with the preparation of spray plans and related records.</p>
          <p>You are responsible for reviewing and verifying all information, calculations, recommendations, and spray plans generated by SPM before use. Compliance with product labels, withholding periods, regulations, and market requirements remains your responsibility.</p>
        </Col>
      </Row>
 
      <Row>
        <Col>
          <h2>Fees and Refunds</h2>
          <p>Fees are payable in advance.</p>
          <p>All payments are final and non-refundable except where required by law.</p>
        </Col>
      </Row>
 
      <Row>
        <Col>
          <h2>Availability</h2>
          <p>We aim to keep SPM available and functioning correctly but do not guarantee uninterrupted access. We may modify, suspend, or discontinue the service at any time.</p>
        </Col>
      </Row>
 
      <Row>
        <Col>
          <h2>Privacy</h2>
          <p>We collect and store information you provide when using SPM, including account details and spray plan data.</p>
          <p>We use this information to operate, support, improve, and secure the service.</p>
          <p>We will not sell your personal information and will take reasonable steps to protect it.</p>
          <p>You may request access to, or correction of, your personal information by contacting support@hortplus.com.</p>
        </Col>
      </Row>
 
      <Row>
        <Col>
          <h2>Intellectual Property</h2>
          <p>SPM and all related software, content, and functionality remain the property of HortPlus or its licensors.</p>
        </Col>
      </Row>
 
      <Row>
        <Col>
          <h2>Liability</h2>
          <p>SPM is provided on an "as is" basis.</p>
          <p>To the maximum extent permitted by law, HortPlus is not liable for any loss, damage, crop loss, production loss, business interruption, or other costs arising from the use of, or reliance on, SPM.</p>
          <p>HortPlus' total liability relating to SPM is limited to the amount paid by you to use the service during the previous 12 months.</p>
        </Col>
      </Row>
 
      <Row>
        <Col>
          <h2>Business Use</h2>
          <p>If you are using SPM for business purposes, you agree that the Consumer Guarantees Act 1993 does not apply to the extent permitted by law.</p>
        </Col>
      </Row>
 
      <Row>
        <Col>
          <h2>Changes</h2>
          <p>We may update these Terms from time to time by publishing an updated version on the SPM website.</p>
        </Col>
      </Row>
 
      <Row>
        <Col>
          <h2>Governing Law</h2>
          <p>These Terms are governed by the laws of New Zealand.</p>
        </Col>
      </Row>
 
      <Row>
        <Col>
          <h2>Contact</h2>
          <p>HortPlus N.Z. Limited</p>
          <p>support@hortplus.com</p>
        </Col>
      </Row>
    </Container>
  );

};

export default observer(TermsOfUse);
